// `Select`'in `items` prop'u (dizi, gruplu dizi ya da kayıt) içindeki değerlerin sırası.
// `SelectValue` seçili değerin dönüş yönünü (sonraki seçenek aşağıdan yükselir, öncekisi yukarıdan iner) buradan bulur.
export function itemValues(items: unknown): unknown[] {
  if (!items) return []
  if (Array.isArray(items)) {
    return items.flatMap((item) => {
      if (item && typeof item === 'object' && 'items' in item) return itemValues(item.items)
      if (item && typeof item === 'object' && 'value' in item) return [item.value]
      return [item]
    })
  }
  return typeof items === 'object' ? Object.keys(items as object) : []
}
